import { render, staticRenderFns } from "./GuideBox.vue?vue&type=template&id=27ef1e7f&scoped=true&"
import script from "./GuideBox.vue?vue&type=script&lang=js&"
export * from "./GuideBox.vue?vue&type=script&lang=js&"
import style0 from "./GuideBox.vue?vue&type=style&index=0&id=27ef1e7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef1e7f",
  null
  
)

export default component.exports